
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer",
      function () {
        return require("private-next-pages/customer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer"])
      });
    }
  